import { connect } from 'react-redux';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import Global from '../../../../store/global-selectors';
import * as Actions from '../../../../store/orders/filtering/orders.filtering.actions';
import FilterView from '../index';
import messages from '../../messages';

const getDisplayName = (isActive) => {
  if (isActive) {
    return <FormattedMessage {...messages.saveView} />;
  }
  return <FormattedMessage {...messages.customView} />;
};

const mapStateToProps = (state, ownProps) => {
  const activeFilterViewId = Global.selectOrdersFilteringActiveFilterViewId(state);
  const isActive = activeFilterViewId === ownProps.filterViewId;
  const displayName = getDisplayName(isActive);

  return {
    activeFilterViewId,
    isActive,
    displayName,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    switchActiveFilterView: (filterViewId) => {
      dispatch(Actions.switchActiveFilterView(filterViewId));
    },
    launchSaveViewModal: () => {
      dispatch(Actions.launchSaveViewModal());
    },
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const isActiveView = stateProps.activeFilterViewId === ownProps.filterViewId;
  return {
    ...ownProps,
    ...stateProps,
    onViewClick: isActiveView ? dispatchProps.launchSaveViewModal : dispatchProps.switchActiveFilterView,
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(FilterView);
